import { useEffect, useState } from 'react';
import { useNotifications } from '../context/NotificationContext';
import '../assets/css/notifications.css';

const NotificationToast = () => {
  const { toastNotification, dismissToast } = useNotifications();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (toastNotification) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [toastNotification]);

  if (!toastNotification) return null;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      case 'cart':
        return '🛒';
      case 'order_update':
        return '📦';
      case 'new_message':
        return '💬';
      case 'price_alert':
        return '💰';
      case 'payment_update':
        return '💳';
      case 'wallet_update':
        return '👛';
      case 'product_update':
        return '🛍️';
      case 'dispute_update':
        return '⚖️';
      default:
        return '🔔';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'success':
      case 'cart':
        return '#22c55e'; // green
      case 'error':
        return '#ef4444'; // red
      case 'warning':
        return '#f59e0b'; // amber
      case 'info':
        return '#3b82f6'; // blue
      case 'order_update':
        return '#3b82f6'; // blue
      case 'new_message':
        return '#8b5cf6'; // purple
      case 'price_alert':
        return '#f59e0b'; // amber
      case 'payment_update':
        return '#10b981'; // green
      case 'wallet_update':
        return '#06b6d4'; // cyan
      case 'product_update':
        return '#6366f1'; // indigo
      case 'dispute_update':
        return '#ef4444'; // red
      default:
        return '#22c55e'; // default green
    }
  };

  return (
    <div className={`notification-toast ${isVisible ? 'show' : ''}`}>
      <div
        className="toast-icon"
        style={{ background: getNotificationColor(toastNotification.type) }}
      >
        {getNotificationIcon(toastNotification.type)}
      </div>

      <div className="toast-content">
        <h4 className="toast-title">{toastNotification.title}</h4>
        <p className="toast-message">{toastNotification.message}</p>
      </div>

      <button className="toast-close" onClick={dismissToast}>
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default NotificationToast;
